export const GUEST_DISPLAY_NAME = "Guest";

const CLERK_USER_ID_PREFIX = "user_";

export function isRegisteredPlayerId(playerId: string): boolean {
  return playerId.startsWith(CLERK_USER_ID_PREFIX);
}
